import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { getOrdersForSelect } from './queries.js';
import { Column, LoadPanel, Lookup, Selection } from 'devextreme-react/data-grid.js';
import { usePayKinds } from 'hooks/index.js';
import { useAuth } from 'contexts/auth.jsx';

const { Popup, DataGrid, Button, CheckBox } = require('devextreme-react');

export const OrderSelector = forwardRef(({ ordersList, proj, onSelected }, ref) => {
  const [orders, setOrders] = useState([]);
  const [visible, setVisible] = useState(false);
  const [withTerminal, setWithTerminal] = useState(false);
  const {options} = useAuth();

  const { payKinds } = usePayKinds();
  const popupRef = useRef();
  const gridRef = useRef();

  useImperativeHandle(ref, () => {
    return {
      show,
    };
  });

  const show = () => {

    setVisible(true)
    gridRef.current?.instance?.selectRows(ordersList.map(r=>r.ref)) 
    
  }

  useEffect(() => {
    const { partUUID, partValue} = options.easyPay; //T300 pay_kind & value
    visible && getOrdersForSelect(ordersList.map((r) => r.ref), proj, withTerminal)
      .then(data=>{
        const handleData = data?.map( doc => {
          if (doc.pay_kind === partUUID) { //check for T300
            doc.doc_amount = doc.services.reduce((prev, curr)=>(prev+curr.quantity*partValue),0);
          }
          return doc;
        })
        setOrders(handleData)
      });
  }, [ordersList, withTerminal, proj, visible, options.easyPay]);

  const renderTitle = () => {
    return (
      <div style={{ display: 'flex', alignItems: 'center', padding: '10px',  }}>
        <div style={{display: 'flex', gap: '5px'}}>
        <Button
            text='Вийти'
            hint='зміни не будуть перенесені в документ' type='danger'
            onClick={() => popupRef.current.instance.hide()}
          />
          <Button
            text='Вибрати' type='success'
            onClick={() => {
              onSelected(gridRef.current?.instance?.getSelectedRowsData());
              popupRef.current.instance.hide();
            }}
          />
        </div>
        <div style={{ paddingLeft: '25px' }}>
          <CheckBox value={withTerminal} onValueChanged={({ value }) => setWithTerminal(value)} text='Термінальні' />
        </div>
      </div>
    );
  };
  return (
    <Popup 
      ref={popupRef} 
      visible={visible} 
      titleRender={renderTitle} 
      closeOnOutsideClick width={'600px'}
      onHiding={()=>setVisible(false)}
      >

      <div style={{height:'100%'}}>
      <DataGrid ref={gridRef} keyExpr={'ref'} dataSource={orders}  paging={{enabled:false}} height={'100%'}  >
        <LoadPanel enabled={false}/>
        <Selection mode='multiple' showCheckBoxesMode={'always'}    />
        <Column dataField={'number_doc'} caption='Номер' />
        <Column dataField={'date'} caption='Дата' format='dd.MM.yyyy hh:mm' dataType={'date'} />
        <Column dataField={'pay_kind'} caption='Опл'>
          <Lookup dataSource={payKinds} valueExpr='ref' displayExpr='name' />
        </Column>
        <Column dataField={'doc_amount'} caption='Сума' />
      </DataGrid>

      </div>
    </Popup>
  );
});
